module.exports = __webpack_public_path__ + "img/contact_code_wechat@2x.74fe1d2b.png";